function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.9983 0.000488281H0V60H89.9983V0.000488281Z",
  fill: "#0052B4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2683 29.9994C39.3163 29.946 39.3638 29.8923 39.4112 29.8384C39.3638 29.8925 39.3153 29.9456 39.2671 29.9994H39.2683Z",
  fill: "#F0F0F0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4601 38.5693L24.3863 42.5969L28.7362 41.5918L26.7881 45.6089L30.2861 48.3828L25.931 49.3646L25.9431 53.829L22.4601 51.0359L18.9772 53.829L18.9893 49.3646L14.6343 48.3828L18.1323 45.6089L16.1841 41.5918L20.5339 42.5969L22.4601 38.5693Z",
  fill: "#F0F0F0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.0393 47.1729L68.9581 49.0939L71.0328 48.6144L70.1036 50.5304L71.7721 51.8536L69.6948 52.3217L69.7004 54.4511L68.0393 53.1191L66.3782 54.4511L66.3838 52.3217L64.3066 51.8536L65.9749 50.5304L65.046 48.6144L67.1207 49.0939L68.0393 47.1729Z",
  fill: "#F0F0F0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M53.4931 21.9932L54.4119 23.9144L56.4866 23.4347L55.5574 25.3509L57.2257 26.6741L55.1485 27.1422L55.1542 29.2718L53.4931 27.9394L51.8318 29.2718L51.8376 27.1422L49.7603 26.6741L51.4286 25.3509L50.4998 23.4347L52.5743 23.9144L53.4931 21.9932Z",
  fill: "#F0F0F0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M65.6394 4.34766L66.5582 6.26891L68.6329 5.78903L67.7037 7.70537L69.372 9.02844L67.2949 9.49672L67.3005 11.6261L65.6394 10.2937L63.9783 11.6261L63.9839 9.49672L61.9067 9.02844L63.575 7.70537L62.6461 5.78903L64.7208 6.26891L65.6394 4.34766Z",
  fill: "#F0F0F0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1052 17.8818L80.024 19.8029L82.0985 19.3234L81.1697 21.2394L82.838 22.5624L80.7607 23.0307L80.7665 25.1601L79.1052 23.828L77.4441 25.1601L77.4497 23.0307L75.3726 22.5624L77.0409 21.2394L76.1117 19.3234L78.1864 19.8029L79.1052 17.8818Z",
  fill: "#F0F0F0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M71.3665 25.6719L72.089 27.8958H74.4275L72.5356 29.2704L73.2584 31.4943L71.3665 30.1199L69.4743 31.4943L70.1971 29.2704L68.3052 27.8958H70.6437L71.3665 25.6719Z",
  fill: "#F0F0F0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9991 0.000488281V5.37103L37.0598 9.78288H44.9991V20.2169H34.6101L44.9991 25.9885V29.9993H40.3094L27.3908 22.823V29.9993H17.6084V21.4612L2.24011 29.9993H0V24.6287L7.93936 20.2169H0V9.78288H10.389L0 4.00928V0.000488281H4.68975L17.6084 7.17697V0.000488281H27.3908V8.53855L42.759 0.000488281H44.9991Z",
  fill: "#F0F0F0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.312 0H19.6871V12.187H0V17.8119H19.6871V29.9993H25.312V17.8119H44.9991V12.187H25.312V0Z",
  fill: "#D80027"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3906 20.2168L44.999 29.9992V27.233L32.3699 20.2168H27.3906Z",
  fill: "#0052B4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3906 20.2168L44.999 29.9992V27.233L32.3699 20.2168H27.3906Z",
  fill: "#F0F0F0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3906 20.2173L44.999 29.9997V27.2335L32.3699 20.2173H27.3906Z",
  fill: "#D80027"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6289 20.2168L0 27.233V29.9992L17.6084 20.2168H12.6289Z",
  fill: "#D80027"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6084 9.78239L0 0V2.76622L12.6291 9.78239H17.6084Z",
  fill: "#0052B4"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6084 9.78239L0 0V2.76622L12.6291 9.78239H17.6084Z",
  fill: "#F0F0F0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6084 9.78239L0 0V2.76622L12.6291 9.78239H17.6084Z",
  fill: "#D80027"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M32.3701 9.78239L44.999 2.76622V0L27.3906 9.78239H32.3701Z",
  fill: "#D80027"
});

var SvgAud = function SvgAud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AUD.a6eee1dc.svg";
export { ForwardRef as ReactComponent };